import AddressCompletion from '../components/AddressCompletion'
import Blockchains from '@depay/web3-blockchains'
import ChangeQuantityDialog from '../dialogs/ChangeQuantityDialog'
import CountryTypeahead from '../components/CountryTypeahead'
import Decimal from "decimal.js"
import DePayWidgets from "@depay/widgets"
import Dialog from '../components/Dialog'
import FlipClock from '../components/FlipClock'
import formatQuantityNumber from '../helpers/formatQuantityNumber'
import LightOrDark from '../helpers/LightOrDark'
import LoadingScreen from "./loading-screen"
import moment from 'moment'
import PoweredBy from '../components/links/PoweredBy'
import React, { useEffect, useState, useRef } from "react"
import Token from '@depay/web3-tokens'
import VatRow from '../components/links/VatRow'
import Web3Exchanges from '@depay/web3-exchanges'
import { Currency } from '@depay/local-currency'
import { ethers } from 'ethers'
import { TokenImage } from '@depay/react-token-image'

export default function(props) {

  const [ link, setLink ] = useState()
  const [ selectedDiscount, setSelectedDiscount ] = useState()
  const [ fullName, setFullName ] = useState(props.name)
  const [ email, setEmail ] = useState(props.email)
  const [ billingAddress, setBillingAddress ] = useState()
  const [ billingAddressData, setBillingAddressData ] = useState()
  const [ shippingAddress, setShippingAddress ] = useState()
  const [ useShippingAddress, setUseShippingAddress ] = useState()
  const [ shippingAddressData, setShippingAddressData ] = useState()
  const [ updateInterval, setUpdateInterval ] = useState(1)
  const [ country, setCountry ] = useState(props.country)
  const [ pending, setPending ] = useState(false)
  const [ success, setSuccess ] = useState(false)
  const [ unlockedContent, setUnlockedContent ] = useState()
  const [ discountCode, setDiscountCode ] = useState('')
  const [ submittingDiscountCode, setSubmittingDiscountCode ] = useState(false)
  const [ validDiscountCode, setValidDiscountCode ] = useState()
  const [ customValues, setCustomValues ] = useState([])
  const [ transaction, setTransaction ] = useState()
  const [ displayedTotal, setDisplayedTotal ] = useState()
  const [ displayedEach, setDisplayedEach ] = useState()
  const [ displayedVat, setDisplayedVat ] = useState()
  const [ showDiscountsDialog, setShowDiscountsDialog ] = useState(false)
  const [ showQuantityDialog, setShowQuantityDialog ] = useState(false)
  const [ originalDisplayedPrice, setOriginalDisplayedPrice ] = useState()
  const [ acceptedBlockchains, setAcceptedBlockchains ] = useState()
  const [ connectedAccount, setConnectedAccount ] = useState()
  const [ wallet, setWallet ] = useState()
  const [ textColor, setTextColor ] = useState()
  const [ currencyRate, setCurrencyRate ] = useState()
  const [ appliedDiscount, setAppliedDiscount ] = useState()
  const [ loadingDiscount, setLoadingDiscount ] = useState(false)
  const [ loadingPrices, setLoadingPrices ] = useState(false)
  const [ startAmount, setStartAmount ] = useState()
  const [ displayCurrencyRate, setDisplayCurrencyRate ] = useState()
  const [ suggestedAmount1, setSuggestedAmount1 ] = useState()
  const [ displayedSuggestedAmount1, setDisplayedSuggestedAmount1 ] = useState()
  const [ suggestedAmount2, setSuggestedAmount2 ] = useState()
  const [ displayedSuggestedAmount2, setDisplayedSuggestedAmount2 ] = useState()
  const [ suggestedAmount3, setSuggestedAmount3 ] = useState()
  const [ displayedSuggestedAmount3, setDisplayedSuggestedAmount3 ] = useState()
  const [ quantitySelection, setQuantitySelection ] = useState([])
  const [ quantityInitialized, setQuantityInitialized ] = useState(false)
  const [ liveQuantityLeft, setLiveQuantityLeft ] = useState()
  const [ liveQuantityJustUpdated, setLiveQuantityJustUpdated ] = useState(false)
  const [ quantity, setQuantity ] = useState(props.quantity || 1)
  const [ showDiscountAvailable ] = useState(!(window.location.search && window.location.search.match("hda=1")))
  const socket = useRef()

  const connectWallet = ()=>{
    setShowDiscountsDialog(false)
    DePayWidgets.Connect().then(({ account, wallet })=>{
      setWallet(wallet)
      setConnectedAccount(account)
    })
  }

  const updateCustomValue = (index, value)=>{
    let newCustomValues = customValues.slice()
    newCustomValues[index] = value
    setCustomValues(newCustomValues)
  }

  const resetLinkPayment = (discount)=> {
    setSelectedDiscount(discount)
    setLink()
    let body
    if(discount) {
      body = JSON.stringify({ discount })
    }
    return fetch(window.location.pathname+window.location.search, {
      body,
      method: 'POST',
      headers: {
        "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content 
      }
    }).then((response)=>{
      response.text().then(async(text)=>{
        let link = JSON.parse(text)
        setTextColor(link?.style?.colors?.buttonText || '#FFFFFF')
        if(link.discounts && link.discounts.length){
          link.discounts = link.discounts.sort((discount)=>discount.percent).reverse()
        }
        if(link.currency) {
          setCurrencyRate(await Currency.rate({ from: link.currency, to: link.displayed_currency === 'local' ? undefined : link.displayed_currency }))
        }
        setLink(link)
        setUseShippingAddress(!!link.requires_shipping_address)
      })
      return response
    })
  }

  const updateLinkPayment = (discount, previousLink)=> {
    let body
    if(discount) {
      body = JSON.stringify({ discount })
    }
    return fetch(window.location.pathname+window.location.search, {
      body,
      method: 'POST',
      headers: {
        "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content 
      }
    }).then((response)=>{
      response.text().then(async(text)=>{
        let link = JSON.parse(text)
        setTextColor(link?.style?.colors?.buttonText || '#FFFFFF')
        if(link.discounts && link.discounts.length){
          link.discounts = link.discounts.sort((discount)=>discount.percent).reverse()
        }
        if(link.currency) {
          setCurrencyRate(await Currency.rate({ from: link.currency, to: link.displayed_currency === 'local' ? undefined : link.displayed_currency }))
        }
        if(previousLink.receiver_image_url) { link.receiver_image_url = previousLink.receiver_image_url }
        if(previousLink.purchase_image_url) { link.purchase_image_url = previousLink.purchase_image_url }
        setLink(link)
      })
      return response
    })
  }

  const submitDiscountCode = (event)=> {
    event.preventDefault()
    setSubmittingDiscountCode(true)
    return fetch(window.location.pathname+window.location.search, {
      body: JSON.stringify({ discount: { code: discountCode }}),
      method: 'POST',
      headers: {
        "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content 
      }
    }).then((response)=>{
      response.json().then((json)=>{
        if(json?.discount) {
          setOriginalDisplayedPrice(displayedTotal)
          setAppliedDiscount({ percent: json.discount.percent, code: json.discount.code })
          setShowDiscountsDialog(false)
          setSubmittingDiscountCode(false)
          setValidDiscountCode(true)
          setLink(json)
        } else {
          setSubmittingDiscountCode(false)
          setValidDiscountCode(false)
        }
      }).catch(()=>{
        setSubmittingDiscountCode(false)
        setValidDiscountCode(false)  
      })
    }).catch(()=>{
      setSubmittingDiscountCode(false)
      setValidDiscountCode(false)
    })

    return false
  }

  const loadUnlockedContent = ()=>{
    return fetch(`${window.location.pathname}/${link.id}/unlock`, {
      body: '{}',
      method: 'POST',
      headers: {
        "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content
      }
    }).then((response)=>{
      response.text().then((text)=>{
        let json = JSON.parse(text)
        setUnlockedContent(json.url)
      })
    }).catch(()=>{
      setTimeout(loadUnlockedContent, 3000)
    })
  }

  const performPayment = (link)=>{
    if(
      (link.requires_name && !fullName) ||
      (link.requires_email && !email) ||
      (link.requires_shipping_address && !shippingAddress) ||
      (link.requires_shipping_address && Object.values(shippingAddressData).length == 0) ||
      (link.requires_billing_address && (useShippingAddress ? !shippingAddress : !billingAddress)) ||
      (link.requires_billing_address && (useShippingAddress ? Object.values(shippingAddressData).length == 0 : Object.values(billingAddressData).length == 0 )) ||
      (link.requires_country && !country) ||
      (link.requires_quantity && !quantity) ||
      (link.custom_fields?.length > 0 && link.custom_fields.length != customValues.filter((value)=>value).length)
    ) {
      return alert("Please provide all required information!")
    }
    setUpdateInterval(false)
    let configuration = {
      track: {
        method: async(payment)=>{
          let response = await fetch(`${window.location.pathname}/track`, {
            method: 'POST',
            body: JSON.stringify({
              payment,
              link,
              full_name: fullName,
              email,
              shipping_address: shippingAddress,
              shipping_address_data: shippingAddressData,
              billing_address: (useShippingAddress ? shippingAddress : billingAddress),
              billing_address_data: (useShippingAddress ? shippingAddressData : billingAddressData),
              country, quantity,
              local_currency: Currency.getCode(),
              custom_values: customValues.map((value, index)=>({ name: link.custom_fields[index].name, value })) 
            }),
            headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content }
          })
          if (response.status == 400) {
            window.location.reload(true)
            throw 'RELOAD!'
          } else if(response.status !== 200) {
            throw 'TRACKING FAILED'
          }
        },
        poll: {
          method: async (payment)=>{
            let response = await fetch(`${window.location.pathname}/release`, {
              method: 'POST',
              body: JSON.stringify({ payment, link }),
              headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content }
            })
            if(response.status == 200) {
              let json = await response.json()
              return json
            }
          },
        },
      },
      sent: ()=>{
        setPending(true)
      },
      succeeded: (_transaction)=>{ 
        if(!transaction) { setTransaction(_transaction) }
        setPending(false)
        setSuccess(true)
      },
      validated: (_transaction)=>{
        if(!transaction) { setTransaction(_transaction) }
        setPending(false)
        setSuccess(true)
      },
      failed: ()=> {
        resetLinkPayment()
        setPending(false)
        setUpdateInterval(1)
      },
      closed: ()=>{
        if(!success) {
          setUpdateInterval(1)
          if(link.limited_quantity) {
            fetch(`${window.location.pathname}/${link.id}/quantity`, {
              method: 'POST',
              headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content }
            })
          }
        }
      }
    }
    configuration.currency = link.displayed_currency === 'local' ? undefined : link.displayed_currency
    configuration.accept = link.accept
    if(link.requires_quantity && link.type == 'payment') {
      configuration.accept = link.accept.map((accept)=>{
        let amountAsBN = ethers.utils.parseUnits(accept.amount, Blockchains[accept.blockchain].currency.decimals)
        amountAsBN = amountAsBN.mul(quantity)
        return {...accept, amount: ethers.utils.formatUnits(amountAsBN, Blockchains[accept.blockchain].currency.decimals)}
        return accept
      })
    }
    configuration.style = link.style
    if(link.type == 'payment') {
      DePayWidgets.Payment({...configuration, wallet })
    } else if (link.type == 'donation' || link.type == 'tip') {
      if(startAmount) {
        configuration.amount = {
          start: parseFloat(startAmount)
        }
      }
      if(link.type == 'donation') {
        configuration.title = "Donation"
      } else if(link.type == 'tip') {
        configuration.title = "Tip"
      }
      DePayWidgets.Payment(configuration)
    }
  }

  const getDisplayCurrency = (link)=>{
    if(link) {
      return link.displayed_currency === 'local' ? undefined : link.displayed_currency
    }
  }

  const updateDisplayedPrice = (link, quantity)=>{
    if(link && link.price && link.price.length && link.currency) {
      let amount = link.price
      if(appliedDiscount){
        amount -= amount*parseFloat(appliedDiscount.percent)/100
      }
      let priceEach = Decimal.div(amount, currencyRate)
      let price = priceEach.mul(quantity || 1)
      setDisplayedVat((new Currency({ amount: price.toNumber()/100*parseFloat(link.included_vat), code: getDisplayCurrency(link) })).toString())
      setDisplayedTotal((new Currency({ amount: price.toNumber(), code: getDisplayCurrency(link) })).toString())
      setDisplayedEach((new Currency({ amount: priceEach.toNumber(), code: getDisplayCurrency(link) })).toString())
    } else if (link && link.accept && link.accept.length == 1) {
      if(link.accept[0].amount) {
        let priceEach = Decimal.mul(link.accept[0].amount, 1)
        let price = priceEach.mul(quantity || 1)
        setDisplayedVat(`${link.accept[0].symbol} ${price/100*parseFloat(link.included_vat)}`)
        setDisplayedTotal(`${link.accept[0].symbol} ${price}`)
        setDisplayedEach(`${link.accept[0].symbol} ${priceEach}`)
      }
    } else if(link && link.accept) {
      let allPaymentsWithAmount = link.accept.filter((payment)=>{ return !!payment.amount })
      setLoadingPrices(true)
      Promise.all(allPaymentsWithAmount.map((payment)=>{
        let USD = Blockchains[payment.blockchain].stables.usd.find((stable)=>stable===payment.token)
        if(USD) { USD = Blockchains[payment.blockchain].tokens.find((token)=>token.address===USD) }
        if(USD){
          return Promise.resolve([{
            amountOut: ethers.utils.parseUnits(payment.amount, USD.decimals),
            exchange: {
              blockchain: payment.blockchain
            },
            decimals: USD.decimals,
          }])
        } else {
          return Web3Exchanges.route({
            blockchain: payment.blockchain,
            tokenIn: payment.token,
            tokenOut: Blockchains[payment.blockchain].stables.usd[0],
            amountIn: parseFloat(payment.amount)
          })
        }
      })).then(async (routes)=>{
        let usdAmounts = routes.map((routes)=>{
          return ethers.utils.formatUnits(
            routes[0].amountOut,
            routes[0].decimals || Blockchains[routes[0].blockchain].tokens.find((token)=>token.address===Blockchains[routes[0].blockchain].stables.usd[0]).decimals,
          )
        })
        let usdMaxAmount = Math.max(...usdAmounts)
        let rate = await Currency.rate({ from: 'USD', to: getDisplayCurrency(link) })
        let priceEach = Decimal.div(usdMaxAmount, rate)
        let price = priceEach.mul(quantity || 1)
        setDisplayedVat((new Currency({ amount: price.toNumber()/100*parseFloat(link.included_vat), code: getDisplayCurrency(link) })).toString())
        setDisplayedTotal((new Currency({ amount: price.toNumber(), code: getDisplayCurrency(link) })).toString())
        setDisplayedEach((new Currency({ amount: priceEach.toNumber(), code: getDisplayCurrency(link) })).toString())
        setLoadingPrices(false)
      })
    }
  }

  useEffect(()=>{
    resetLinkPayment()
    return undefined
  }, [])

  useEffect(()=>{
    if(success && link.unlock_url) { loadUnlockedContent() }

    const preventReload = (event) => {
      if(success && !!link.forward_to) {
        const msg = 'Are you sure you want to reload this page?'
        event.preventDefault()
        event.returnValue = msg
        return msg
      }
    }
    window.addEventListener('beforeunload', preventReload);
    return ()=>{
      window.removeEventListener('beforeunload', preventReload);
    }
  }, [success])
  
  useEffect(()=>{
    if(!appliedDiscount && displayedTotal && connectedAccount && link && link.discounts && link.discounts.length) {
      setLoadingDiscount(true)
      Promise.all(link.discounts.map((discount)=>{
        if(discount.tokens === undefined) { return Promise.resolve([]) }
        return Promise.all(discount.tokens.map((token)=>{
          return new Promise((resolve)=>{
            if(token.address && token.id) {
              return (new Token({ blockchain: token.blockchain, address: token.address })).balance(connectedAccount, token.id).then((balance)=>{
                resolve(balance)
              }).catch(()=>resolve())
            } else if (token.address && !token.id) {
              return (new Token({ blockchain: token.blockchain, address: token.address })).balance(connectedAccount).then(resolve).catch(()=>resolve())
            } else if (token.addresses) {
              return Promise.all(token.addresses.map((address)=>{
                return (new Token({ blockchain: token.blockchain, address: address })).balance(connectedAccount)
              })).then((balances)=>{
                const balance = balances.find((balance, index)=>balance && balance.toString() !== '0')
                if(balance){
                  resolve({ index: balances.indexOf(balance), balance })
                } else { resolve() }
              }).catch(()=>resolve())
            }
          })
        }))
      })).then((discountBalances)=>{
        let discount, token
        discountBalances.forEach((tokenBalances, discountIndex)=>{
          if(discount){ return }
          tokenBalances.forEach((tokenBalance, tokenIndex)=>{
            if(token){ return }
            if(typeof tokenBalance === 'object' && tokenBalance.balance && tokenBalance.balance.toString() !== '0') {
              discount = link.discounts[discountIndex]
              token = discount.tokens[tokenIndex]
              token.address = token.addresses[tokenBalance.index]
              token.addresses = undefined
            } else if(tokenBalance && !tokenBalance?.balance && tokenBalance.toString() !== '0') {
              discount = link.discounts[discountIndex]
              token = discount.tokens[tokenIndex]
            }
          })
        })
        if(discount && token) {
          discount = { percent: discount.percent, token, account: connectedAccount }
          setOriginalDisplayedPrice(displayedTotal)
          setAppliedDiscount(discount)
          resetLinkPayment(discount).then(()=>setLoadingDiscount(false))
        } else {
          setLoadingDiscount(false)
        }
      })
    }
  }, [appliedDiscount, displayedTotal, link, connectedAccount])

  useEffect(()=>{
    if(link == undefined){ return }
    if(link?.type == 'donation' || link?.type == 'tip'){ return }
    if(link && link.requires_quantity && !quantityInitialized) {
      setQuantityInitialized(true)
      if(link && link.requires_quantity) {
        setQuantitySelection(link.requires_quantity)
        setQuantity(Math.min(Math.max((quantity || link.requires_quantity?.min), link.requires_quantity?.min), link.requires_quantity?.max))
      }
    }
    if(link && link.limited_quantity && !socket.current) {
      socket.current = new WebSocket(location.host.match(/^(localhost|127\.0\.0\.1)/) || location.host.match(/^(buy\.lvh\.me)/) || location.host.match(/^(link\.lvh\.me)/) ? `ws://${window.location.host}/cable` : `wss://${window.location.host}/cable`)
      socket.current.onopen = async function(event) {
        const msg = {
          command: 'subscribe',
          identifier: JSON.stringify({
            link_id: link.link_id,
            channel: 'LinkQuantityLeftChannel'
          }),
        }
        socket.current.send(JSON.stringify(msg))
      }
      
      socket.current.onmessage = function(event) {
        const item = JSON.parse(event.data)
        if(item.type === "ping" || !item.message) { return }
        if(item.message.quantity_left != undefined) {
          setLiveQuantityLeft(item.message.quantity_left)
          setLiveQuantityJustUpdated(true)
          setTimeout(()=>{ setLiveQuantityJustUpdated(false) }, 300)
        }
      }
      
      socket.current.onerror = function(error) {
        console.log('WebSocket Error: ', error)
      }
    }
  }, [link])

  useEffect(() => {
    const interval = setInterval(() => {
      if(updateInterval === false) {
        // payment has been attempted/traced no more updates!!!
      } else if(updateInterval >= 60) {
        updateLinkPayment(selectedDiscount, link)
        setUpdateInterval(1)
      } else {
        setUpdateInterval(updateInterval+1)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [updateInterval, selectedDiscount])

  useEffect(()=>{
    updateDisplayedPrice(link, quantity)
  }, [link, quantity])
  
  useEffect(()=>{
    if(link?.accept) {
      setAcceptedBlockchains([...new Set(link.accept.map((payment)=>payment.blockchain))])
    }
  }, [link])

  useEffect(()=>{
    if(link && link.currency) {
      let displayCurrency = link.displayed_currency === 'local' ? undefined : link.displayed_currency
      Currency.rate({ from: link.currency, to: displayCurrency }).then((_displayCurrencyRate)=>{
        setDisplayCurrencyRate(_displayCurrencyRate)
      })
    }
  }, [link])

  useEffect(()=>{
    if(!link) { return }
    let displayCurrency = link.displayed_currency === 'local' ? undefined : link.displayed_currency
    if(link?.suggestion1 && displayCurrencyRate) {
      let amount = parseFloat(link.suggestion1)
      amount /= displayCurrencyRate
      amount = Math.ceil(amount)
      setSuggestedAmount1(amount)
      setDisplayedSuggestedAmount1(new Currency({ amount, code: displayCurrency }).toString({ minimumFractionDigits: 0 }))
    } else {
      setSuggestedAmount1()
      setDisplayedSuggestedAmount1()
    }
    if(link?.suggestion2 && displayCurrencyRate) {
      let amount = parseFloat(link.suggestion2)
      amount /= displayCurrencyRate
      amount = Math.ceil(amount)
      setSuggestedAmount2(amount)
      setDisplayedSuggestedAmount2(new Currency({ amount, code: displayCurrency }).toString({ minimumFractionDigits: 0 }))
    } else {
      setSuggestedAmount2()
      setDisplayedSuggestedAmount2()
    }
    if(link?.suggestion3 && displayCurrencyRate) {
      let amount = parseFloat(link.suggestion3)
      amount /= displayCurrencyRate
      amount = Math.ceil(amount)
      setSuggestedAmount3(amount)
      setDisplayedSuggestedAmount3(new Currency({ amount, code: displayCurrency }).toString({ minimumFractionDigits: 0 }))
    } else {
      setSuggestedAmount3()
      setDisplayedSuggestedAmount3()
    }
  }, [link, displayCurrencyRate])

  if(!link){ return(<LoadingScreen/>) }

  return(
    <div className="d-flex min-vh-100 align-items-center">

      { link.requires_quantity && 
        <ChangeQuantityDialog
          open={ showQuantityDialog }
          close={ ()=> setShowQuantityDialog(false) }
          primaryColor={ link?.style?.colors?.primary }
          textColor={ textColor }
          min={ link?.requires_quantity?.min }
          max={ link?.requires_quantity?.max }
          limit={ link?.limited_quantity }
          quantity={ quantity }
          update={ (value)=>setQuantity(value) }
        />
      }

      <Dialog
        open={ showDiscountsDialog }
        close={ ()=> setShowDiscountsDialog(false) }
        header={ 'Receive a Discount' }
        body={
          <div>
            <div>
              <div>
                { link && link.discounts && link.discounts.length &&
                  <div className="mb-2">
                    { link.discounts && link.discounts.some((discount)=>discount.tokens && discount.tokens.length > 0) && 
                      <div className="card mb-1 p-1 flex-column">
                        <div className="px-2 py-2 d-flex w-100">
                          <div className="text-black-50 px-1">
                            By owning one of the following tokens
                          </div>
                        </div>
                        { link.discounts.reduce((accumulator, currentValue)=>[...accumulator, ...currentValue.tokens], []).map((token, index)=>{
                          let blockchain = Blockchains.findByName(token.blockchain)
                          return (
                            <a href={ token.link || blockchain.explorerUrlFor({ token: token.address }) } key={ index } className="link-dark card-hover rounded-2 px-1 py-2 d-flex w-100" target="_blank">
                              <div className="pe-1 ps-1 d-flex align-items-center position-relative">
                                { token.image && 
                                  <img className="rounded-circle token-image-medium" src={ token.image } />
                                }
                                { !token.image && 
                                  <TokenImage className="rounded-circle token-image-medium" blockchain={ token.blockchain } address={ token.address } id={ token.id } />
                                }
                                <img title={ `on ${blockchain.label}` } className="position-absolute rounded-1 shadow-sm" style={{ backgroundColor: blockchain.logoBackgroundColor, height: '1.3rem', width: '1.3rem', padding: '0.1rem', bottom: 0, right: 0 }} src={ blockchain.logo } />
                              </div>
                              <div className="d-flex align-items-center ps-3">
                                <div className="lh-sm">
                                  { !token.symbol &&
                                    <div>
                                      <div><strong>{ token.name }</strong></div>
                                    </div>
                                  }
                                  { token.symbol &&
                                    <div>
                                      <div><strong>{ token.symbol }</strong></div>
                                      <div>{ token.name }</div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </a>
                          )
                        } ) }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
        footer={
          <div className="p-2 text-center">
            {
              link.discounts.filter((discount)=>discount.codes).length > 0 &&
              <form className="mb-1 pt-2" onSubmit={ submitDiscountCode }>
                <div className="mb-1">
                  <input value={ discountCode } onChange={(event)=>{
                    setValidDiscountCode()
                    setDiscountCode(event.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase())
                  }} required className={`form-control font-size-m w-100 text-center bg-white border py-2 ${ validDiscountCode === false ? 'is-invalid' : '' }`} placeholder="Enter discount code"/>
                  { validDiscountCode === false && <div className="invalid-feedback pb-1">Entered discount code is invalid</div> }
                </div>
                <div>
                  <button disabled={ submittingDiscountCode } type="submit" className="btn rounded-2 btn-lg py-2 mb-2 btn-primary w-100" style={{ background: link?.style?.colors?.primary, borderColor: link?.style?.colors?.primary }}>
                    <div className="py-1 w-100" style={{ color: link?.style?.colors?.buttonText }}>
                      Apply discount code
                    </div>
                  </button>
                </div>
              </form>
            }
          </div>
        }
      />

      <div className="w-100 pt-2 pb-0 pb-md-5">
        <form onSubmit={(event)=>{
          event.preventDefault()
          performPayment(link)
        }}>
          <div className="d-inline-block w-100">
            <div className="row">
              <div className="col-12 col-md-6 pt-4 pt-md-0">
                <div className="d-flex justify-content-end h-100 px-4 px-md-0 pb-4 pb-md-0" style={{ color: textColor }}>
                  
                  <div className="container row pe-0 pe-md-5 justify-content-end">

                    <div className="col-5 d-flex flex-column payment-link-column left">
                      
                      <div className="position-relative pb-2 d-flex align-items-center">
                        { link.receiver_image_url && link.receiver_image_url != '' &&
                          <div className="rounded-circle d-inline-block me-2" style={{ position: 'relative', top: '-2px', width: "30px", height: "30px", backgroundColor: 'rgba(0,0,0,0.3)', backgroundImage: `url(${link.receiver_image_url})`, backgroundPosition: 'center center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}/>
                        }
                        <span>{ link.receiver_name && link.receiver_name.length ? `${link.receiver_name}` : null }</span>
                      </div>

                      <div className="d-flex align-items-center pb-2">

                        { link.type === 'payment' &&
                          <div className="pe-3">
                            {loadingPrices && <div style={{padding: "5px 0 9px"}}><div className="rounded-1 skeleton position-relative" style={{ top: '3px', width: '240px', height: '38px' }}/></div>}
                            {!loadingPrices && <h2 className="mb-0 fw-bold" style={{ color: textColor }}>{ displayedTotal }</h2>}
                          </div>
                        }

                        { (link.type === 'donation' || link.type === 'tip') &&
                          <div className="pe-3">
                            <h6 className="fs-6 m-0" style={{ color: textColor }}>
                              { link.purchase_name }
                            </h6>
                          </div>
                        }

                        { link.purchase_image_url && link.purchase_image_url != '' &&
                          <div className="flex-grow-1 d-block text-end m-auto align-items-center pt-1">
                            <div className="rounded-circle d-inline-block" style={{ position: 'relative', width: "68px", height: "68px", backgroundColor: 'rgba(0,0,0,0.3)', backgroundImage: `url(${link.purchase_image_url})`, backgroundPosition: 'center center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}/>
                          </div>
                        }

                      </div>

                      <div className="flex-grow-1" style={{ minHeight: '20vh' }}>

                        { link.type == 'payment' && 
                          <div>
                            <div className="pt-3">

                              {
                                (link.purchase_description && link.purchase_description.length > 0) &&
                                <div className="d-flex align-items-center pb-4">
                                  <div className="flex-grow-1 lh-sm">{ link.purchase_description }</div>
                                </div>
                              }

                              {
                                (link.purchase_name && link.purchase_name.length > 0) &&
                                <div className="d-flex align-items-center">
                                  <div className="flex-grow-1 lh-sm">{ link.purchase_name }</div>
                                  <div>
                                    {loadingPrices && <div style={{padding: "1px"}}><div className="rounded-1 skeleton position-relative" style={{ top: '1px', width: '100px', height: '22px' }}/></div>}
                                    {!loadingPrices && <span>{ originalDisplayedPrice || displayedTotal }</span>}
                                  </div>
                                </div>
                              }

                              { originalDisplayedPrice &&
                                <div className="pt-1" style={{opacity: 0.7}}>
                                  <hr style={{ borderColor: textColor }}/>
                                  <div className="d-flex align-items-center font-size-s">
                                    <div className="flex-grow-1">Discount</div>
                                    <div>-{ appliedDiscount.percent }%</div>
                                  </div>
                                </div>
                              }

                              { link.requires_quantity && 
                                <div className="pb-1 pt-1 row">
                                  <div className="col-8">
                                      
                                    { quantitySelection &&
                                      <label className="d-inline-block text-start" onClick={()=>{setShowQuantityDialog(true)}}>
                                        <div className={`d-inline-block position-relative ${ LightOrDark(textColor) == 'light' ? 'hover-target-opacity-20' : 'hover-target-opacity-10'}`} role="button">
                                          <div className="rounded-1 hover-target-opacity" style={{ position: 'absolute', backgroundColor: textColor, top: 0, bottom: 0, left: 0, right: 0 }}/>
                                          <div className="py-1 px-2 font-size-s">
                                            Quantity: { (new Intl.NumberFormat()).format(quantity) }
                                          </div>
                                        </div>
                                      </label>
                                    }

                                  </div>
                                  <div className="col-4 text-end">
                                    { quantity && quantity > 1 &&
                                      <>
                                        {loadingPrices && <div className="d-inline-block" style={{padding: "1px"}}><div className="rounded-1 skeleton position-relative" style={{ top: '4px', width: '90px', height: '18px' }}/></div>}
                                        {!loadingPrices && <span className="font-size-s opacity-50">{ displayedEach } each</span>}
                                      </>
                                    }
                                  </div>
                                </div>
                              }

                              { link.discounts && link.discounts.length > 0 && appliedDiscount === undefined && showDiscountAvailable &&
                                <div className="pt-2">
                                  <div className="d-flex align-items-center font-size-s">
                                    <div className="flex-grow-1">
                                      <div type="button" className="hover-opacity-50" title="Click to see available discounts" onClick={ ()=>setShowDiscountsDialog(true) }>
                                        Discount available
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }

                              <div className="pt-1">

                                { link.included_vat != undefined && link.receiver_country &&
                                  <div style={{opacity: 0.7}}>
                                    <hr style={{ borderColor: textColor }}/>
                                    <div className="d-flex align-items-center font-size-s">
                                      <VatRow
                                        displayedVat={ displayedVat }
                                        link={ link }
                                        displayCurrency={ link.displayed_currency === 'local' ? undefined : link.displayed_currency }
                                        vatCountry={ link.receiver_country }
                                        billingAddress={ billingAddressData }
                                        shippingAddress={ shippingAddressData }
                                        selectedCountry={ country }
                                      />
                                    </div>
                                  </div>
                                }

                                <hr style={{ borderColor: textColor }}/>
                                <div className="d-flex align-items-center">
                                  <div className="flex-grow-1">Total</div>
                                  <>
                                    {loadingPrices && <div style={{padding: "1px"}}><div className="rounded-1 skeleton position-relative" style={{ top: '1px', width: '100px', height: '22px' }}/></div>}
                                    {!loadingPrices && <div>{ displayedTotal }</div>}
                                  </>
                                </div>
                              </div>

                            </div>
                          </div>
                        }

                        { (link.type === 'donation' || link.type === 'tip') && success == false &&
                          <div className='pt-4'>
                            { (link.type == 'donation' || link.type == 'tip') && displayedSuggestedAmount1 && 
                              <div className="mb-3">
                                <button onClick={()=>{ setStartAmount(suggestedAmount1) }} type="submit" className={`btn rounded-2 btn-lg py-0 btn-primary ${link.suggestion2 && 'me-2'}`} style={{ background: 'transparent', border: 'transparent' }}>
                                  <div className="py-2 w-100" style={{ color: textColor }}>
                                    { displayedSuggestedAmount1 }
                                  </div>
                                </button>
                              </div>
                            }
                            { (link.type == 'donation' || link.type == 'tip') && displayedSuggestedAmount2 && 
                              <div className="mb-3">
                                <button onClick={()=>{ setStartAmount(suggestedAmount2) }} type="submit" className={`btn rounded-2 btn-lg py-0 btn-primary ${link.suggestion3 && 'me-2'}`} style={{ background: 'transparent', border: 'transparent' }}>
                                  <div className="py-2 w-100" style={{ color: textColor }}>
                                    { displayedSuggestedAmount2 }
                                  </div>
                                </button>
                              </div>
                            }
                            { (link.type == 'donation' || link.type == 'tip') && displayedSuggestedAmount3 && 
                              <div className="mb-3">
                                <button onClick={()=>{ setStartAmount(suggestedAmount3) }} type="submit" className={`btn rounded-2 btn-lg py-0 btn-primary`} style={{ background: 'transparent', border: 'transparent' }}>
                                  <div className="py-2 w-100" style={{ color: textColor }}>
                                    { displayedSuggestedAmount3 }
                                  </div>
                                </button>
                              </div>
                            }
                          </div>
                        }

                      </div>

                      <div className="align-self-end w-100 d-none d-md-block pt-6">
                        <PoweredBy link={ link } textColor={ textColor }/>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 ps-0 ps-md-5 pt-md-2">
                
                <div className="container row pe-0 pe-md-5">
                  
                  <div className="col-5 payment-link-column right px-4 px-md-0 bg-grey pb-0 pt-4 pt-md-0">

                    { link.limited_quantity != undefined  &&
                      <div className="pb-2">
                        <div className="pt-1 pb-1">
                          {
                            (liveQuantityLeft != null ? liveQuantityLeft <= 0 : (link.limited_quantity - (link.quantity_sold || 0)) <= 0) &&
                            <div className={`d-inline-block alert alert-info p-2 px-3 lh-sm mb-0 font-size-s fw-medium ${liveQuantityJustUpdated ? 'glow' : ''}`}>
                              Sold out
                            </div>
                          }
                          {
                            (liveQuantityLeft != null ? liveQuantityLeft > 0 : (link.limited_quantity - (link.quantity_sold || 0)) > 0) &&
                            <div className={`d-inline-block alert alert-info p-2 px-3 lh-sm mb-0 font-size-s fw-medium ${liveQuantityJustUpdated ? 'glow' : ''}`}>
                              Only { formatQuantityNumber(liveQuantityLeft != null ? liveQuantityLeft : link.limited_quantity - (link.quantity_sold || 0)) } left
                            </div>
                          }
                        </div>
                      </div>
                    }

                    { link.start_date != undefined && moment(link.start_date).toDate() > new Date() &&
                      <div className="pb-2">
                        <h2 className="h5 mb-0">
                          Starts in
                        </h2>
                        <div className="pt-1" style={{ height: '60px' }}>
                          <FlipClock value={ moment(link.start_date).toISOString() }/>
                        </div>
                      </div>
                    }
                    { link.end_date != undefined && (!link.start_date || moment(link.start_date).toDate() <= new Date()) &&
                      <div className="pb-2">
                        <h2 className="h5 mb-0">
                          { new Date() < moment(link.end_date).toDate() && <>Ends in</>}
                          { new Date() >= moment(link.end_date).toDate() && <>Ended</>}
                        </h2>
                        <div className="pt-1" style={{ height: '60px' }}>
                          { new Date() < moment(link.end_date).toDate() && <FlipClock value={ moment(link.end_date).toISOString() }/>}
                          { new Date() >= moment(link.end_date).toDate() && 
                            <div className="alert alert-info p-2 px-3 lh-sm mb-0">
                              <i className="fas fa-exclamation-circle me-2"></i>
                              Ended { moment(link.end_date).format('LLL') }
                            </div>
                          }
                        </div>
                      </div>
                    }

                    <h2 className="h5 mb-0">
                      { link.type == 'payment' && <span>Pay </span> }
                      { link.type == 'donation' && <span>Donate </span> }
                      { link.type == 'tip' && <span>Tip </span> }
                      with crypto
                    </h2>

                    <div className="pt-1 pb-3">
                      { acceptedBlockchains?.map((name, index)=>{
                        let blockchain = Blockchains.findByName(name)
                        return(
                          <img
                            key={name}
                            className={`rounded-1 ${index > 0 ? 'ms-1' : ''}`}
                            title={`Pay on ${blockchain.label}`}
                            src={ blockchain.logo }
                            style={{ boxShadow: '0 0 4px rgba(0,0,0,0.08)', background: blockchain.logoBackgroundColor, width: "28px", height: "28px", padding: '1px' }}
                          />
                        )
                      }) }
                    </div>

                    <div className="flex-grow-1" style={{ minHeight: '34vh' }}>
                      { (link.requires_name || link.requires_email || link.requires_shipping_address || link.requires_billing_address || link.requires_country || link.custom_fields?.length > 0) &&
                        <div className="pb-2">
                          { link.requires_name &&
                            <div className="pb-2">
                              <label className="d-block text-start">
                                <small className="text-black-50 pb-2">Full Name</small>
                                <input disabled={ pending || success } value={ fullName || '' } onChange={(event)=>{ setFullName(event.target.value) }} id="fullName" required className="d-block form-control mb-1 rounded-1 bg-white border" placeholder="Enter your full name" type="text"/>
                              </label>
                            </div>
                          }
                          { link.requires_email &&
                            <div className="pb-2">
                              <label className="d-block text-start">
                                <small className="text-black-50 pb-2">E-Mail</small>
                                <input disabled={ pending || success } value={ email || '' } onChange={(event)=>{ setEmail(event.target.value) }} id="email" required className="d-block form-control mb-1 rounded-1 bg-white border" placeholder="your@email.com" type="email"/>
                              </label>
                            </div>
                          }
                          { link.requires_shipping_address && 
                            <div className="pb-2">
                              <div className="d-block text-start">
                                <small className="text-black-50 pb-2">Shipping Address</small>
                                <AddressCompletion
                                  required
                                  fullName={ fullName }
                                  id="shippingAddress"
                                  label="shipping address"
                                  disabled={ pending || success }
                                  onChange={(string, data)=>{
                                    setShippingAddress(string)
                                    setShippingAddressData(data)
                                  }}
                                />
                              </div>
                            </div>
                          }
                          { link.requires_billing_address && 
                            <div className="pb-2">
                              <div className="d-block text-start">
                                <small className="text-black-50 pb-2">Billing Address</small>
                                <AddressCompletion
                                  required
                                  fullName={ fullName }
                                  requiresShippingAddress={ link.requires_shipping_address }
                                  useShippingAddress={ useShippingAddress }
                                  setUseShippingAddress={ setUseShippingAddress }
                                  id="billingAddress"
                                  label="billing address"
                                  disabled={ pending || success }
                                  onChange={(string, data)=>{
                                    setBillingAddress(string)
                                    setBillingAddressData(data)
                                  }}
                                />
                              </div>
                            </div>
                          }
                          { link.requires_country && 
                            <div className="pb-2">
                              <label className="d-block text-start">
                                <small className="text-black-50 pb-2">Country</small>
                                <CountryTypeahead
                                  required
                                  id="country"
                                  placeholder="Select your country"
                                  className="d-block mb-1 rounded-1 bg-white border"
                                  onChange={setCountry}
                                  selected={country}
                                />
                              </label>
                            </div>
                          }
                          {
                            link.custom_fields?.length > 0 &&
                            link.custom_fields.map((field, index)=>(
                              <div className="pb-2" key={ index }>
                                <label className="d-block text-start">
                                  <small className="text-black-50 pb-2">{ field.name }</small>
                                  { field.type == 'string' && <input disabled={ pending || success } onChange={ (event)=>updateCustomValue(index, event.target.value) } type="text" required className="d-block form-control mb-1 rounded-1 bg-white border" placeholder={ `Please enter ${field.name.toLowerCase()}` }/> }
                                  { field.type == 'number' && <input disabled={ pending || success } onChange={ (event)=>updateCustomValue(index, parseFloat(event.target.value)) } type="number" required className="d-block form-control mb-1 rounded-1 bg-white border" placeholder={ `Please enter ${field.name.toLowerCase()}` }/> }
                                  { field.caption && <div className="font-size-s lh-sm pb-2 px-1"><small className="text-black-50">{ field.caption }</small></div> }
                                </label>
                              </div>
                            ))
                          }
                        </div>
                      }

                      { success == false &&
                        <div>
                          {
                            !!link.unlock_url &&
                            <div className="w-100">
                              <button onClick={ ()=>{} } type="button" className="btn btn-sm btn-light rounded-2 py-2 opacity-50 w-100" title="A successful payment will unlock content.">
                                <i className="fas fa-unlock me-2"></i>
                                <span className="ms-1">unlocks content</span>
                              </button>
                            </div>
                          }
                          <div className="pt-2">

                            { !pending &&
                              <div>
                                { link.type == 'payment' &&
                                  <div>
                                    { link.discounts && link.discounts.filter((discount)=>discount.tokens && discount.tokens.length).length > 0 && connectedAccount == undefined && appliedDiscount == undefined &&
                                      <button type="button" onClick={ connectWallet } className="btn rounded-2 btn-lg py-2 btn-primary w-100" style={{ background: link?.style?.colors?.primary, borderColor: link?.style?.colors?.primary }}>
                                        <div className="py-1 w-100" style={{ color: link?.style?.colors?.buttonText }}>
                                          Connect Wallet
                                        </div>
                                      </button>
                                    }
                                    { !(link.discounts && link.discounts.filter((discount)=>discount.tokens && discount.tokens.length).length && connectedAccount == undefined && appliedDiscount == undefined) &&
                                      <div>
                                        { loadingDiscount &&
                                          <button type="button" className="disabled btn rounded-2 btn-lg py-2 btn-primary w-100" style={{ background: link?.style?.colors?.primary, borderColor: link?.style?.colors?.primary }}>
                                            <div className="py-1 w-100" style={{ color: link?.style?.colors?.buttonText }}>
                                              Loading
                                            </div>
                                          </button>
                                        }
                                        { !loadingDiscount &&
                                          !(((link.start_date && moment(link.start_date).toDate() > new Date()) || (link.end_date && new Date() >= moment(link.end_date).toDate())) ? true : false ) &&
                                          !(link.limited_quantity == null ? false : (liveQuantityLeft != null ? liveQuantityLeft <= 0 : (link.limited_quantity - (link.quantity_sold || 0)) <= 0)) &&
                                          <button
                                            type="submit"
                                            className="btn rounded-2 btn-lg py-2 btn-primary w-100"
                                            style={{ background: link?.style?.colors?.primary, borderColor: link?.style?.colors?.primary }}
                                          >
                                            <div className="py-1 w-100" style={{ color: link?.style?.colors?.buttonText }}>
                                              Pay
                                            </div>
                                          </button>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                                { link.type == 'donation' &&
                                  <button onClick={()=>{ setStartAmount() }} type="submit" className="btn rounded-2 btn-lg py-2 btn-primary w-100" style={{ background: link?.style?.colors?.primary, borderColor: link?.style?.colors?.primary }}>
                                    <div className="py-1 w-100" style={{ color: link?.style?.colors?.buttonText }}>
                                      Donate
                                    </div>
                                  </button>
                                }
                                { link.type == 'tip' &&
                                  <button onClick={()=>{ setStartAmount() }} type="submit" className="btn rounded-2 btn-lg py-2 btn-primary w-100" style={{ background: link?.style?.colors?.primary, borderColor: link?.style?.colors?.primary }}>
                                    <div className="py-1 w-100" style={{ color: link?.style?.colors?.buttonText }}>
                                      Tip
                                    </div>
                                  </button>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                      { success == true &&
                        <div>
                          {
                            !!link.unlock_url &&
                            unlockedContent == null &&
                            <div className="w-100">
                              <button onClick={ ()=>{} } type="button" className="btn skeleton d-flex align-items-center justify-content-center btn-sm btn-light rounded-2 py-2 opacity-50 w-100" title="Loading unlocked content.">
                                <i className="fas fa-unlock me-2"></i>
                                <span className="ms-1">loading unlocked content</span>
                              </button>
                            </div>
                          }
                          {
                            !!link.unlock_url &&
                            unlockedContent != null &&
                            <div className="w-100">
                              <a href={ unlockedContent } target="_blank" rel="noopener noreferrer" type="button" className="btn d-flex align-items-center justify-content-center btn-sm btn-light rounded-2 py-2 opacity-50 w-100">
                                <i className="fas fa-unlock me-2"></i>
                                <span className="ms-1 text-truncate w-100">{ unlockedContent }</span>
                              </a>
                            </div>
                          }
                          <div className="position-relative mt-3" style={{ height: '250px' }}>
                            <div className="payment-receipt w-100">
                              <div className="payment-receipt-shadow"></div>
                              <div className="payment-receipt-inner text-center">
                                <div className="p-2">
                                  <i className="fs-2 fas fa-check-circle font-size-xs"></i>
                                </div>
                                <div>
                                  <h5 className="fs-3 fw-bold mb-1">Payment was successful</h5>
                                </div>
                                <div className="opacity-50">
                                  Thank you for your payment.
                                </div>
                                <div className="pt-4 text-center">
                                  { transaction &&
                                    <div className="w-50 d-inline-block text-truncate">
                                      <a href={ transaction.url } target="_blank" rel="noopener noreferrer">{ transaction.id }</a>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="payment-receipt-slot"></div>
                          </div>
                        </div>
                      }
                    </div>

                    <div className="align-self-end w-100 d-block d-md-none pt-5 pb-3 text-center">
                      <PoweredBy link={ link } textColor={ '#430137' }/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>    
  )
}
